module.exports = __webpack_public_path__ + "img/journal_.1209004d.svg";